// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-pos-icon-container{
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-pos-icon-container.pointer{
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomIcon/PosCustomIcon.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".custom-pos-icon-container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.custom-pos-icon-container.pointer{\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
